import { useForm } from "react-hook-form";
import StyledButton from "../../components/styled/StyledButton";
import StyledInput from "../../components/styled/StyledInput";
import {
  ForgotPasswordFormData,
  ForgotPasswordSchema,
} from "../../types/forms/auth/forgotPasswordData.form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForgotPassword } from "../../api/auth.api";
import ArrowLeft from "../../assets/icons/arrow-left.svg?react";
import { useNavigate } from "react-router-dom";
import Paths from "../../constants/paths";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  const { control, handleSubmit } = useForm<ForgotPasswordFormData>({
    resolver: zodResolver(ForgotPasswordSchema),
  });

  const { mutate } = useForgotPassword();

  const onSubmit = async (data: ForgotPasswordFormData) => {
    mutate(data);
    navigate(Paths.auth.resetPasswordConfirmation, {
      state: { email: data.email },
    });
  };

  return (
    <div className="bg-brand600 flex min-h-screen w-screen items-center justify-center">
      <div className="mx-4 flex flex-col items-center gap-4 rounded-2xl bg-white px-6 py-6 md:min-h-[500px] md:min-w-[600px] md:gap-16 md:px-16 md:py-12">
        <img src="/images/pelican-logo.png" className="h-32 w-32" />
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-center text-3xl font-medium text-black">Mot de passe oublié ?</h1>
          <p className="text-center text-sm text-gray-600">
            Nous allons vous envoyer un lien de réinitialisation.{" "}
          </p>
        </div>

        <div className="flex w-full flex-col gap-4">
          <StyledInput title="Email" control={control} name="email" />
        </div>

        <div className="flex w-full flex-col gap-2">
          <StyledButton onClick={handleSubmit(onSubmit)}>
            Envoyer le lien de réinitialisation
          </StyledButton>
          <StyledButton mode="secondary" onClick={() => navigate(-1)}>
            <div className="gap flex items-center justify-center gap-2">
              <ArrowLeft />
              Retour à la connexion
            </div>
          </StyledButton>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
